const formatGroupName = (
  teamName: string,
  formatFor: 'frontend' | 'backend'
) => {
  if (formatFor === 'frontend') {
    return teamName.slice(3, teamName.length - 5)
  }
  if (formatFor === 'backend') {
    return `V2 ${teamName} Team`
  }
  return teamName
}

export default formatGroupName
